// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .reference-brand-selector {
  margin-left: -6px;
  min-width: 150px;
}
.presize-root .group-reference-brand-label {
  font-size: 12px;
  cursor: pointer;
  margin-right: 4px;
  color: #66676e;
}
.presize-root .ant-select-selection-placeholder {
  color: #a2a3a8;
}
.presize-root .reference-brand-selector-dropdown {
  min-width: 150px;
}
.presize-root .reference-brand-button {
  border: none;
  box-shadow: none;
  margin-left: -6px;
}
.presize-root .reference-brand-button:hover {
  background-color: #fff;
}
.presize-root .anticon.reference-brand-button-icon {
  color: #a2a3a8;
}
/*# sourceMappingURL=ReferenceBrandSelector.css.map */`, "",{"version":3,"sources":["webpack://./ReferenceBrandSelector.less","webpack://./src/components/SizingGroup/GroupHeader/ReferenceBrandSelector/ReferenceBrandSelector.less"],"names":[],"mappings":"AAAA;EAEE,iBAAA;EACA,gBAAA;ACAF;ADHA;EAME,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACAF;ADTA;EAYE,cAAA;ACAF;ADZA;EAeE,gBAAA;ACAF;ADfA;EAkBE,YAAA;EACA,gBAAA;EACA,iBAAA;ACAF;ADCE;EACE,sBAAA;ACCJ;ADvBA;EA0BE,cAAA;ACAF;AACA,qDAAqD","sourcesContent":[".presize-root { \n .reference-brand-selector {\n  margin-left: -6px;\n  min-width: 150px;\n}\n.group-reference-brand-label {\n  font-size: 12px;\n  cursor: pointer;\n  margin-right: 4px;\n  color: #66676e;\n}\n.ant-select-selection-placeholder {\n  color: #a2a3a8;\n}\n.reference-brand-selector-dropdown {\n  min-width: 150px;\n}\n.reference-brand-button {\n  border: none;\n  box-shadow: none;\n  margin-left: -6px;\n  &:hover {\n    background-color: #fff;\n  }\n}\n.anticon.reference-brand-button-icon {\n  color: #a2a3a8;\n}\n \n}",".presize-root .reference-brand-selector {\n  margin-left: -6px;\n  min-width: 150px;\n}\n.presize-root .group-reference-brand-label {\n  font-size: 12px;\n  cursor: pointer;\n  margin-right: 4px;\n  color: #66676e;\n}\n.presize-root .ant-select-selection-placeholder {\n  color: #a2a3a8;\n}\n.presize-root .reference-brand-selector-dropdown {\n  min-width: 150px;\n}\n.presize-root .reference-brand-button {\n  border: none;\n  box-shadow: none;\n  margin-left: -6px;\n}\n.presize-root .reference-brand-button:hover {\n  background-color: #fff;\n}\n.presize-root .anticon.reference-brand-button-icon {\n  color: #a2a3a8;\n}\n/*# sourceMappingURL=ReferenceBrandSelector.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
